<template>
  <div>
    <div class="search_head">
      <a-form layout="inline" style="padding: 0">
        <a-form-item label="">
          <a-input v-model="kw" style="width:250px"></a-input>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" html-type="submit" @click="query()">
            搜索
          </a-button>
        </a-form-item>
      </a-form>
    </div>
    <div class="search_content">
      <a-table :columns="columns" :data-source="table" bordered size="small" :loading="loading" :pagination="pagination"
        :rowKey="(record, index) => { return index }" @change="change">
        
      </a-table>
    </div>
  </div>
</template>
<script>
import { get, post } from "../../assets/js/request";
export default {
  data() {
    return {
      kw: '',
      table: [],
      pagination: {
        current: 1,
        pageSize: 20,
        total: 0,
      },
      columns: [
        {
          title: '序号',
          customRender: (text, record, index) => `${index + 1}`,
          width: 50,
        },
        {
          title: "任务id",
          dataIndex: "task_id",
        }, {
          title: "任务名",
          dataIndex: "name",
        },
        , {
          title: "产品名",
          dataIndex: "product.product_name",
        }, {
          title: "关键词数",
          dataIndex: "keywords_num",
        }, {
          title: "视频数",
          dataIndex: "video_num",
        }, {
          title: "图片数",
          dataIndex: "image_num",
        }, {
          title: "音乐数",
          dataIndex: "music_num",
        }, {
          title: "时间",
          dataIndex: "create_time",
        }, {
          title: "已合成",
          dataIndex: "finished_num",
        }, {
          title: "状态",
          dataIndex: "state",
        },

      ],
      loading: false,
    };
  },
  created() {
    this.loadtable();
  },
  methods: {
    loadtable() {
      this.loading = true;
      get("/task/list", {
        page: this.pagination.current,
        size: this.pagination.pageSize,
        search: this.kw,
      }).then((res) => {
        this.loading = false;
        this.table = res.data.data;
        this.pagination.total = res.data.total;
      });
    },
    change(pagination) {
      this.pagination = pagination;
      this.loadtable();
    },
    query() {
      this.pagination.current = 1;
      this.loadtable();
    },
  },
};
</script>